import React, {Component} from "react";
import { Button, Col, Container, FormLabel, Row, Form } from "react-bootstrap";
import { withRouter } from "../utils/withRouter";
import cart from "../models/cart-model";
import CartTicket from "../components/cart-ticket";
import CartEvent from "../components/cart-event";
import CommonService from "../services/common.service";
import config from "../config.json";
import axios from "axios";
import signalDispatcherInstance from "../utils/signalDispatcher";
import userEventService from "../services/user-event.service";

let common = new CommonService();
interface CheckoutPageState {
    cart: cart;
    timeLeft?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    emailConfirm?: string;
    phone?: string;
    city?: string;
    postalCode?: string;
    street?: string;
    houseNumber?: string;
    country?: string;
    countryList: any;
    heardAboutUs?: string;
    paymentMethod?: string;
    termsAccepted?: boolean;
    emailSubscription?: boolean;
    sendTicketsByEmail?: boolean;
    hotels: any;
    missingData: boolean;
    isCompany: boolean;
    companyName?: string;
    vatNumber?: string;
    translations: Record<string, any>;
    userIP?: string;
    browserInfo?: string;
}

interface CheckoutPageProps {
    params: {
        id: string;
    };
}

class CheckoutPage extends Component<CheckoutPageProps, CheckoutPageState> {
    constructor(props: CheckoutPageProps) {
        super(props);
        let cartData = localStorage.getItem('cart');
        let initialCart = cartData ? JSON.parse(cartData) : { cartId: '0', currency: 'HUF', totalPrice: '0' };
        const hotel = localStorage.getItem('hotel') || '0';
        const heard = hotel !== '0' ? hotel.includes('hotel_') ? hotel : 'hotel_' + hotel : '0';
        this.state = {
            cart: initialCart,
            hotels: [],
            countryList: [],
            heardAboutUs: heard || '',
            missingData: true,
            isCompany: false, 
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'checkout_page_open');
        this.setState({ timeLeft: this.getTimeToLeft() });
        setInterval(() => {
            this.setState({ timeLeft: this.getTimeToLeft() });
        }, 1000);

        common.getHotels().then(hotels => {
            this.setState({ hotels: hotels ? hotels : [] });
        }).catch(error => {
            console.error('Error fetching hotels:', error);
        });

        common.getCountries().then(countries => {
            this.setState({ countryList: countries ? countries : [] });
        }).catch(error => {
            console.error('Error fetching countries:', error);
        });

        fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
            this.setState({ userIP: data.ip });
        })
        .catch(error => {
            console.error('Error fetching IP address:', error);
        });

        const browserInfo = navigator.userAgent;
        this.setState({ browserInfo });
    }

    private getTimeToLeft() {
        const cartData = localStorage.getItem('cart');
        if (cartData) {
            const storedExpiryTime = localStorage.getItem('cartExpiryTime');
            if (storedExpiryTime) {
                const expiryTime = parseInt(storedExpiryTime);
                if (expiryTime > 0) {
                    const minutes = Math.floor(expiryTime / 60);
                    const seconds = expiryTime % 60;
                    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                }
            }
        }
        return '00:00';
    }

    private formatPrice(price: number) {
        return price !== null ? price.toLocaleString() : '';
    }

    private getTotalPrice() {
        let total = 0;
        if (this.state.cart) {
            if (this.state.cart.tickets) {
                total += this.state.cart.tickets.reduce((sum, ticket) => sum + ((ticket.price as number) * ticket.quantity), 0);
            }
            if (this.state.cart.events) {
                this.state.cart.events.forEach(event => {
                    total += (event.ages?.adult ?? 0) * (event.agePrices?.adult ?? 0);
                    total += (event.ages?.junior ?? 0) * (event.agePrices?.junior ?? 0);
                    total += (event.ages?.child ?? 0) * (event.agePrices?.child ?? 0);
                });
                this.state.cart.events.forEach(event => {
                    if (event && event.mealsList && event.mealsList.length > 0) {
                        event.mealsList.forEach(meal => {
                            if (meal.price_huf && meal.quantity) {
                                total += meal.price_huf * meal.quantity;
                            }
                        });
                    }
                });
            }
        }
        return this.formatPrice(total);
    }

    private checkMissingData() {
        let missing = false;
        if (!this.state.firstName || this.state.firstName.trim() === '') {
            missing = true;
        }
        if (!this.state.lastName || this.state.lastName.trim() === '') {
            missing = true;
        }
        if (!this.state.email || this.state.email.trim() === '') {
            missing = true;
        }
        if (!this.state.emailConfirm || this.state.emailConfirm.trim() === '') {
            missing = true;
        }
        if (this.state.email !== this.state.emailConfirm) {
            missing = true;
        }
        if (!this.state.phone || this.state.phone.trim() === '') {
            missing = true;
        }
        if (!this.state.city || this.state.city.trim() === '') {
            missing = true;
        }
        if (!this.state.postalCode || this.state.postalCode.trim() === '') {
            missing = true;
        }
        if (!this.state.street || this.state.street.trim() === '') {
            missing = true;
        }
        if (!this.state.houseNumber || this.state.houseNumber.trim() === '') {
            missing = true;
        }
        if (!this.state.country || this.state.country.trim() === '') {
            missing = true;
        }
        if (!this.state.termsAccepted) {
            missing = true;
        }
        if (this.state.isCompany) {
            if (!this.state.companyName || this.state.companyName.trim() === '') {
                missing = true;
            }
            if (!this.state.vatNumber || this.state.vatNumber.trim() === '') {
                missing = true;
            }
        }
        return missing;
    }

    componentDidUpdate(prevProps: Readonly<CheckoutPageProps>, prevState: Readonly<CheckoutPageState>, snapshot?: any): void {
        const missing = this.checkMissingData();
        if (missing !== prevState.missingData) {
            this.setState({ missingData: missing });
        }
    }

    sendOrder(payInEmail: boolean) {
        userEventService.sendEvent('action', payInEmail ? 'checkout_payment_link' : 'checkout_start_payment', {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phone: this.state.phone,
            city: this.state.city,
            postalCode: this.state.postalCode,
            street: this.state.street,
            houseNumber: this.state.houseNumber,
            country: this.state.country,
            heardAboutUs: this.state.heardAboutUs,
            isCompany: this.state.isCompany,
            companyName: this.state.companyName,
            vatNumber: this.state.vatNumber,
            payInEmail
        });
        if (payInEmail) {
            alert(this.state.translations.filter((item: any) => item.setting_name === 'PAY_IN_EMAIL_ALERT')[0].setting_value_text);
        }
        let cartData = {};
        const cartStr = localStorage.getItem('cart');
        if (cartStr) {
            const cartObj = JSON.parse(cartStr);
            if (cartObj && cartObj.tickets && cartObj.tickets.length > 0) {
                cartObj?.tickets?.forEach((value: any) => {
                    if (value !== null && value !== undefined) {
                        const cartItem = {
                            [value.subProductId]: {
                                isEvent: false,
                                product_id: value.subProductId,
                                qty: value.quantity,
                                discount: 0
                            }
                        };
                        cartData = { ...cartData, ...cartItem };
                    }
                });
            }
            if (cartObj && cartObj.events && cartObj.events.length > 0) {
                cartObj.events.forEach((event: any) => {
                    if (event && event.mealsList && event.mealsList.length > 0) {
                        event.mealsList.forEach((meal: any) => {
                            if (meal && meal.id && meal.quantity && meal.quantity > 0) {
                                const cartItem = {
                                    [meal.id]: {
                                        isEvent: true,
                                        product_id: meal.id,
                                        event_id: event.id,
                                        qty: meal.quantity,
                                        discount: 0
                                    }
                                };
                                cartData = { ...cartData, ...cartItem };        
                            }
                        });
                    }
                });
            }
        }
        const country_code = this.state.country ? this.state.country.split('_')[1] : 'HU';
        const country_id = this.state.country ? parseInt(this.state.country.split('_')[0]) : 2;
        const selectedHotelId = this.state.heardAboutUs && this.state.heardAboutUs.includes('hotel_') ? this.state.heardAboutUs.replace('hotel_', '') : '0';
        let hotelID = localStorage.getItem('hotel');
        hotelID = hotelID?.replace('hotel_', '') || selectedHotelId || '0';
        const data = {
            shopping_cart_data: {
                uuid: localStorage.getItem('uuid') || '',
                back_url: config.BACKURL,
                customerEmail: this.state.email,
                phone: this.state.phone,
                viaemail: payInEmail,
                hotel: hotelID,
                heardabout: this.state.heardAboutUs ? this.state.heardAboutUs : localStorage.getItem('hotel') || '0',
                invoice: {
                    isCompany: this.state.isCompany,
                    name: this.state.firstName + ' ' + this.state.lastName,
                    company: this.state.isCompany ? (this.state.companyName || '') : '',
                    vatnumber: this.state.isCompany ? (this.state.vatNumber || '') : '',
                    zip: this.state.postalCode,
                    city: this.state.city,
                    country_id: country_id,
                    country: country_code,
                    address: this.state.street + ' ' + this.state.houseNumber
                },
                cart: cartData
            }
        };

        const orderDetailsData = {
            order_uuid: localStorage.getItem('uuid') || '',
            order_hotel: hotelID,
            order_sales: localStorage.getItem('username') || '', 
            order_cart: cartData,
            order_customer_fname: this.state.firstName,
            order_customer_lname: this.state.lastName,
            order_customer_email: this.state.email,
            order_customer_phone: this.state.phone,
            order_customer_city: this.state.city,
            order_customer_zip: this.state.postalCode,
            order_customer_street: this.state.street,
            order_customer_house: this.state.houseNumber,
            order_customer_country: country_code,
            order_customer_ip: this.state.userIP || '',
            order_customer_browser: this.state.browserInfo || '',
            order_customer_hotel: this.state.heardAboutUs ? this.state.heardAboutUs : localStorage.getItem('hotel') || '0',
        };

        axios.post(config.API + '/frontendCreateOrderDetails', orderDetailsData, {headers: {'Content-Type': 'application/json'}}).then(response => {
            if (response.data && response.data.success) {
                localStorage.setItem('orderID', response.data.data);
            }
        }).catch(error => {
            console.error('Error calling resevation:', error);
        });

        axios.post(config.API + '/frontendCheckout', data, {headers: {'Content-Type': 'application/json'}}).then(response => {
            if (response.data && response.data.success) {
                if (!payInEmail && response.data && response.data.data && response.data.data.paymentUrl) {
                    userEventService.sendEvent('redirect', 'simplepay_redirect', { paymentUrl: response.data.data.paymentUrl });
                    window.location.href = response.data.data.paymentUrl;
                }
                if (payInEmail && response.data && response.data.data) {
                    window.location.href = '/completed';
                }
                if (!payInEmail && response.data && response.data.data && !response.data.data.paymentUrl) {
                    this.resetCart();
                }
            }
            else {
                alert(this.state.translations.filter((item: any) => item.setting_name === 'CHECKOUT_ERROR')[0].setting_value_text || 'An error occurred during checkout. Please try again.');
            }
        }).catch(error => {
            console.error('Error calling resevation:', error);
        });
    }

    resetCart() {
        localStorage.setItem('sessionExpired', 'true');
        localStorage.removeItem('cart');
        localStorage.removeItem('cartExpiryTime');
        localStorage.removeItem('uuid');
        signalDispatcherInstance.emit('updateCartTicket', null);
        common.getUID().then((uid: any) => {
            if (uid && uid.uuid) {
                localStorage.setItem('uuid', uid.uuid);
            }
            else {
                localStorage.setItem('uuid', '');
            }
            window.location.href = '/';
        });
    }

    goBack() {
        window.history.back();
    }

    render() {
        return (
            <Container className="oc-cart">
                <Row key={1} className="oc-page-title">
                    <Col lg={8} md={12} sm={12} xs={12}>
                        <h2>{this.state.translations.filter((item: any) => item.setting_name === 'CHECKOUT')[0].setting_value_text}</h2>
                    </Col>
                    {this.state.timeLeft && parseInt(this.state.timeLeft) > 0 &&
                    <Col lg={4} md={12} sm={12} xs={12} className="oc-text-timer">
                        {this.state.translations.filter((item: any) => item.setting_name === 'REMAINING_TIME')[0].setting_value_text}: <strong>{this.state.timeLeft || '00:00'}</strong>
                    </Col>
                    }
                </Row>
                <Row key={3} className="oc-cart-items">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        {this.state.cart && this.state.cart.tickets && this.state.cart.tickets.length > 0 &&
                            <CartTicket key={'tickets'} tickets={this.state.cart.tickets} hidden={true} />
                        }
                        {this.state.cart && this.state.cart.events && this.state.cart.events.length > 0 &&
                            <CartEvent key={'events'} events={this.state.cart.events} hidden={true} />
                        }
                        {(!this.state.cart || ((!this.state.cart.tickets || this.state.cart.tickets.length === 0) && (!this.state.cart.events || this.state.cart.events.length === 0))) &&
                            <p className="cart-is-empty">{this.state.translations.filter((item: any) => item.setting_name === 'EMPTY_CART')[0].setting_value_text}...</p>
                        }
                    </Col>
                </Row>
                {((this.state.cart && this.state.cart.tickets && this.state.cart.tickets.length > 0) || (this.state.cart && this.state.cart.events && this.state.cart.events.length > 0)) &&
                <Row key={4} className="oc-cart-total">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <div>
                            <h4>{this.state.translations.filter((item: any) => item.setting_name === 'TOTAL_PRICE')[0].setting_value_text}: </h4>
                            <h3>
                                {this.getTotalPrice()} HUF <small>({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</small>
                            </h3>
                        </div>
                    </Col>
                </Row>
                }
                <Row key={'billinginfo'} className="oc-checkout-form">
                    <Col lg={10} md={12} sm={12} xs={12}>
                        <h4>{this.state.translations.filter((item: any) => item.setting_name === 'BILLING_INFO')[0].setting_value_text}</h4>
                    </Col>
                    <Col className="align-right" lg={2} md={12} sm={12} xs={12}>
                        <Form.Switch className="inline-item" type="switch" id="isCompany" checked={this.state.isCompany} onChange={(e) => this.setState({ isCompany: e.target.checked })}></Form.Switch> <FormLabel for={'isCompany'}>{this.state.translations.filter((item: any) => item.setting_name === 'COMPANY_BILL')[0].setting_value_text}</FormLabel>
                    </Col>
                </Row>
                <Row key={5} className="oc-checkout-form">
                    <Col lg={6} md={6} sm={6} xs={6}>
                        <input 
                            type="text" 
                            className={`oc-input oc-input-full form-control ${!this.state.firstName?.trim() ? 'input-error' : ''}`} 
                            placeholder={this.state.translations.filter((item: any) => item.setting_name === 'FIRSTNAME')[0].setting_value_text + ' *'} 
                            value={this.state.firstName} 
                            onChange={(e) => this.setState({ firstName: e.target.value })} 
                        />
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                        <input 
                        type="text" 
                        className={`oc-input oc-input-full form-control ${!this.state.lastName?.trim() ? 'input-error' : ''}`} 
                        placeholder={this.state.translations.filter((item: any) => item.setting_name === 'LASTNAME')[0].setting_value_text + ' *'} 
                        value={this.state.lastName} 
                        onChange={(e) => this.setState({ lastName: e.target.value })} />
                    </Col>
                </Row>
                <Row key={6} className="oc-checkout-form">
                    <Col lg={3} md={6} sm={6} xs={6}>
                        <input type="text" className={`oc-input oc-input-full form-control sm-mb-1 ${!this.state.city?.trim() ? 'input-error' : ''}`} placeholder={this.state.translations.filter((item: any) => item.setting_name === 'CITY')[0].setting_value_text + ' *'} value={this.state.city} onChange={(e) => this.setState({ city: e.target.value })} />
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={6}>
                        <input type="text" className={`oc-input oc-input-full form-control ${!this.state.postalCode?.trim() ? 'input-error' : ''}`} placeholder={this.state.translations.filter((item: any) => item.setting_name === 'ZIP')[0].setting_value_text + ' *'} value={this.state.postalCode} onChange={(e) => this.setState({ postalCode: e.target.value })} />
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={6}>
                        <input type="text" className={`oc-input oc-input-full form-control ${!this.state.street?.trim() ? 'input-error' : ''}`} placeholder={this.state.translations.filter((item: any) => item.setting_name === 'STREET')[0].setting_value_text + ' *'} value={this.state.street} onChange={(e) => this.setState({ street: e.target.value })} />
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={6}>
                        <input type="text" className={`oc-input oc-input-full form-control ${!this.state.houseNumber?.trim() ? 'input-error' : ''}`} placeholder={this.state.translations.filter((item: any) => item.setting_name === 'HOUSENUMBER')[0].setting_value_text + ' *'} value={this.state.houseNumber} onChange={(e) => this.setState({ houseNumber: e.target.value })} />
                    </Col>
                </Row>
                <Row key={7} className="oc-checkout-form">
                    <Col lg={6} md={6} sm={6} xs={6}>
                        <select className={`oc-input oc-input-full form-control ${!this.state.country?.trim() ? 'input-error' : ''}`} value={this.state.country} onChange={(e) => this.setState({ country: e.target.value })}>
                            <option value="">{this.state.translations.filter((item: any) => item.setting_name === 'COUNTRY')[0].setting_value_text + ' *'}</option>
                            {this.state.countryList && this.state.countryList.length > 0 && this.state.countryList.map((country: any) => (
                                <option key={country.key} value={country.key}>{country.value}</option>
                            ))}
                        </select>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                        <input type="text" className={`oc-input oc-input-full form-control ${!this.state.phone?.trim() ? 'input-error' : ''}`} placeholder={this.state.translations.filter((item: any) => item.setting_name === 'PHONENUMBER')[0].setting_value_text + ' *'} value={this.state.phone} onChange={(e) => this.setState({ phone: e.target.value })} />
                    </Col>
                </Row>
                <Row key={8} className="oc-checkout-form">
                    <Col lg={6} md={12} sm={12} xs={12}>
                        <input type="text" className={`oc-input oc-input-full form-control sm-mb-1 ${!this.state.email?.trim() ? 'input-error' : ''}`} placeholder={this.state.translations.filter((item: any) => item.setting_name === 'EMAILADDRESS')[0].setting_value_text + ' *'} value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} />
                    </Col>
                    <Col lg={6} md={12} sm={12} xs={12}>
                        <input type="text" className={`oc-input oc-input-full form-control ${!this.state.emailConfirm?.trim() ? 'input-error' : ''}`} placeholder={this.state.translations.filter((item: any) => item.setting_name === 'EMAILCONFIRM')[0].setting_value_text + ' *'} value={this.state.emailConfirm} onChange={(e) => this.setState({ emailConfirm: e.target.value })} />
                    </Col>
                </Row>
                <Row key={9} className="oc-checkout-form">
                    <Col lg={6} md={12} sm={12} xs={12}>
                        <select disabled={localStorage.getItem('hotel') !== '' && localStorage.getItem('hotel') !== null && localStorage.getItem('hotel') !== 'undefined' ? true : false} className={`oc-input oc-input-full form-control sm-mb-1`} value={this.state.heardAboutUs} onChange={(e) => this.setState({ heardAboutUs: e.target.value })}>
                            <option value="">{this.state.translations.filter((item: any) => item.setting_name === 'HEARD')[0].setting_value_text}</option>
                            {this.state.hotels && this.state.hotels.length > 0 && this.state.hotels.map((hotel: any) => (
                                <option key={hotel.key} value={hotel.key} selected={hotel.key === localStorage.getItem('hotel') ? true : false}>{hotel.value}</option>
                            ))}
                        </select>
                    </Col>
                    {this.state.isCompany &&
                    <>
                        <Col lg={3} md={6} sm={6} xs={6}>
                            <input type="text" className={`oc-input oc-input-full form-control ${!this.state.companyName?.trim() ? 'input-error' : ''}`} placeholder={this.state.translations.filter((item: any) => item.setting_name === 'COMPANY_NAME')[0].setting_value_text + ' *'} value={this.state.companyName} onChange={(e) => this.setState({ companyName: e.target.value })} />
                        </Col>
                        <Col lg={3} md={6} sm={6} xs={6}>
                            <input type="text" className={`oc-input oc-input-full form-control ${!this.state.vatNumber?.trim() ? 'input-error' : ''}`} placeholder={this.state.translations.filter((item: any) => item.setting_name === 'VAT_NUMBER')[0].setting_value_text + ' *'} value={this.state.vatNumber} onChange={(e) => this.setState({ vatNumber: e.target.value })} />
                        </Col>
                    </>
                    }
                </Row>
                <Row key={10} className="oc-checkout-form">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <p>{this.state.translations.filter((item: any) => item.setting_name === 'EMAIL_NOTE')[0].setting_value_text}</p>
                        <input type="checkbox" className="form-check-input" id="subscribeEmail" checked={this.state.emailSubscription} onChange={(e) => this.setState({ emailSubscription: e.target.checked })} /> <FormLabel for={'subscribeEmail'}>{this.state.translations.filter((item: any) => item.setting_name === 'EMAIL_SUBSCRIBE')[0].setting_value_text}</FormLabel><br />
                        <input type="checkbox" className={`form-check-input ${!this.state.termsAccepted ? 'input-error' : ''}`} id="termsAccept" checked={this.state.termsAccepted} onChange={(e) => this.setState({ termsAccepted: e.target.checked })} /> <FormLabel for={'termsAccept'}>* {this.state.translations.filter((item: any) => item.setting_name === 'ACCEPT_PART1')[0].setting_value_text} <a href="/terms-of-service" rel="noreferrer">{this.state.translations.filter((item: any) => item.setting_name === 'ACCEPT_PART2')[0].setting_value_text}</a></FormLabel>
                    </Col>
                </Row>
                <Row key={13} className="oc-checkout-info">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <p>* : {this.state.translations.filter((item: any) => item.setting_name === 'MANDATORY')[0].setting_value_text}</p>
                        {localStorage.getItem('language') === 'hu' &&
                        <p>
                            Tudomásul veszem, hogy az adatkezelő, a Budapest Sightseeing Kft. (4400 Nyíregyháza, Bocskai utca 16) felhasználói fiókjában, a <a href="https://budapestsightseeing.hu/" target="_blank" rel="noreferrer">https://budapestsightseeing.hu/</a> felhasználói adatbázisában tárolt alábbi személyes adatokat a SimplePay Zrt., mint adatfeldolgozó kezeli.
                            Az adatkezelő által továbbított adatok a következők: név, cím, megye, telefonszám, e-mail cím, cégnév, adószám.
                            Az adatfeldolgozó által végzett adatkezelési tevékenység jellege és célja a SimplePay Adatvédelmi Szabályzatban a következő linken található:
                            <a href="https://simplepay.hu/adatkezelesi-tajekoztatok/" target="_blank" rel="noreferrer">https://simplepay.hu/adatkezelesi-tajekoztatok/</a>
                        </p>
                        }
                        {localStorage.getItem('language') === 'en' &&
                        <p>
                            I acknowledge the following personal data stored in the user account of the data controller Budapest Sightseeing Kft. (4400 Nyíregyháza, Bocskai utca 16) 
                            in the user database of <a href="https://budapestsightseeing.hu/" target="_blank" rel="noreferrer">https://budapestsightseeing.hu/</a> will be handled over to SimplePay Zrt. and is trusted as data processor. 
                            The data transferred by the data controller are the following: name, address, counrty, phone number, email address, company name, VAT number. 
                            The nature and purpose of the data processing activity performed by the data processor in the SimplePay Privacy Policy can be found at the following link:
                            <a href="https://simplepay.hu/adatkezelesi-tajekoztatok/" target="_blank" rel="noreferrer">https://simplepay.hu/adatkezelesi-tajekoztatok/</a>
                        </p>
                        }
                    </Col>
                </Row>
                <Row key={11} className="oc-checkout-form">
                    <Col lg={12} md={12} sm={12} xs={12} className="oc-simplepay-info">
                        {this.state.translations.filter((item: any) => item.setting_name === 'SIMPLEPAY')[0].setting_value_text}
                    </Col>
                    <Col lg={6} md={12} sm={12} xs={12}>
                        <img src="/simplepay.png" alt="Secure Payment" className="oc-secure-payment-image" />
                    </Col>
                    <Col lg={6} md={12} sm={12} xs={12}>
                        <Button onClick={() => this.sendOrder(false)} disabled={this.state.missingData} variant="primary" className="oc-btn-alert mobile-button-mtop">{this.state.translations.filter((item: any) => item.setting_name === 'START_PAYMENT')[0].setting_value_text}</Button>
                    </Col>
                </Row>
                <Row key={12} className="oc-checkout-action">
                    <Col lg={6} md={12} sm={12} xs={12} className="only-on-desktop">
                        <Button onClick={() => this.goBack()} variant="primary" className="oc-btn-default">{this.state.translations.filter((item: any) => item.setting_name === 'BACK')[0].setting_value_text}</Button>
                    </Col>
                    <Col lg={6} md={12} sm={12} xs={12}>
                        <Button onClick={() => this.sendOrder(true)} disabled={this.state.missingData} variant="primary" className="oc-btn-alert">{this.state.translations.filter((item: any) => item.setting_name === 'PAYMENT_LINK')[0].setting_value_text}</Button>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(CheckoutPage);